const faqItems = [
  {
    question: 'What is a Sugargoo Spreadsheet?',
    answer: 'A Sugargoo Spreadsheet is a curated collection of product links organized by category, helping shoppers find the best sneakers, clothing, and accessories available through Sugargoo. Each entry is verified by the community for quality and reliability.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20open%20laptop%20on%20clean%20white%20desk%20displaying%20organized%20spreadsheet%20interface%20with%20product%20thumbnails%20and%20category%20tabs%2C%20bright%20airy%20co-working%20space%20with%20natural%20daylight%20streaming%20through%20large%20windows%2C%20indoor%20plants%20adding%20green%20freshness%2C%20organized%20productive%20workspace%20with%20notebook%20and%20coffee%20cup%2C%20professional%20yet%20warm%20atmosphere&width=500&height=350&seq=benefit-guide-v4&orientation=landscape',
    icon: 'ri-question-answer-line',
  },
  {
    question: 'How often is the spreadsheet updated?',
    answer: 'Our spreadsheet directory is updated daily with new finds and refreshed links. Dead links are removed promptly, and new product discoveries are added as the community shares them.',
    image: 'https://readdy.ai/api/search-image?query=Large%20wall%20calendar%20with%20colorful%20handwritten%20notes%20and%20circled%20dates%20near%20a%20modern%20workspace%20with%20fresh%20flowers%20in%20vase%2C%20warm%20morning%20sunlight%20creating%20soft%20shadows%2C%20organized%20creative%20office%20with%20pastel%20stationery%20supplies%20neatly%20arranged%20on%20wooden%20desk%2C%20refreshing%20positive%20atmosphere&width=500&height=350&seq=benefit-update-v4&orientation=landscape',
    icon: 'ri-refresh-line',
  },
  {
    question: 'Is the spreadsheet free to use?',
    answer: 'Absolutely. The Sugargoo Spreadsheet directory is completely free to browse. All product links redirect to our main platform where you can explore and shop at your convenience.',
    image: 'https://readdy.ai/api/search-image?query=Open%20hands%20gently%20holding%20colorful%20folded%20paper%20notes%20and%20miniature%20shopping%20icons%20floating%20upward%20against%20soft%20cream%20background%2C%20warm%20uplifting%20concept%20photography%2C%20freedom%20and%20accessibility%20theme%2C%20bright%20natural%20lighting%20with%20gentle%20bokeh%20effect%2C%20cheerful%20and%20inviting%20composition&width=500&height=350&seq=benefit-free-v4&orientation=landscape',
    icon: 'ri-check-double-line',
  },
];

export default function BenefitsSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="mb-12">
          <span className="text-[11px] text-foreground-500 uppercase tracking-widest font-semibold">FAQ</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 max-w-2xl leading-tight">
            Everything You Need to Know About Sugargoo Spreadsheets
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 group hover:border-primary-200 transition-all">
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.question}
                  title={item.question}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-6 md:p-7">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-9 h-9 flex items-center justify-center bg-primary-50 rounded-lg">
                    <i className={`${item.icon} text-primary-600 text-base`}></i>
                  </span>
                </div>
                <h3 className="font-heading text-[17px] font-bold text-foreground-950 mb-2">
                  {item.question}
                </h3>
                <p className="text-[14px] text-foreground-700 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-10">
          <h3 className="font-heading text-xl font-bold text-foreground-950 mb-6">Sugargoo Spreadsheet vs Manual Search</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-[14px]">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left py-3 pr-6 font-bold text-foreground-900">Feature</th>
                  <th className="text-left py-3 pr-6 font-bold text-primary-700">Sugargoo Spreadsheet</th>
                  <th className="text-left py-3 font-bold text-foreground-500">Manual Search</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-background-100">
                  <td className="py-3 pr-6 text-foreground-800 font-medium">Time Saving</td>
                  <td className="py-3 pr-6 text-primary-700 font-semibold"><i className="ri-check-line mr-1"></i> Yes</td>
                  <td className="py-3 text-foreground-500"><i className="ri-close-line mr-1"></i> No</td>
                </tr>
                <tr className="border-b border-background-100">
                  <td className="py-3 pr-6 text-foreground-800 font-medium">Organized Links</td>
                  <td className="py-3 pr-6 text-primary-700 font-semibold"><i className="ri-check-line mr-1"></i> Yes</td>
                  <td className="py-3 text-foreground-500"><i className="ri-close-line mr-1"></i> No</td>
                </tr>
                <tr className="border-b border-background-100">
                  <td className="py-3 pr-6 text-foreground-800 font-medium">Product Categories</td>
                  <td className="py-3 pr-6 text-primary-700 font-semibold"><i className="ri-check-line mr-1"></i> Yes</td>
                  <td className="py-3 text-foreground-500">Limited</td>
                </tr>
                <tr className="border-b border-background-100">
                  <td className="py-3 pr-6 text-foreground-800 font-medium">Beginner Friendly</td>
                  <td className="py-3 pr-6 text-primary-700 font-semibold"><i className="ri-check-line mr-1"></i> Yes</td>
                  <td className="py-3 text-foreground-500"><i className="ri-close-line mr-1"></i> No</td>
                </tr>
                <tr>
                  <td className="py-3 pr-6 text-foreground-800 font-medium">Community Verified</td>
                  <td className="py-3 pr-6 text-primary-700 font-semibold"><i className="ri-check-line mr-1"></i> Yes</td>
                  <td className="py-3 text-foreground-500"><i className="ri-close-line mr-1"></i> No</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}